import PropTypes from "prop-types";

import { combineClassNames } from "../../utils/appUtils";

import WPButton from "../WPButton";
import { WPTypography } from "../WPTypography";

import "./WPEmptyStates.scss";
const WPEmptyStates = ({
  description,
  titleMsg,
  className,
  icon: Icon,
  buttonText,
  onButtonClick,
  customIconClass,
}) => {
  return (
    <div className={combineClassNames("flex-center", className)}>
      <div className="flex-center empty-states-wrapper">
        {Icon && (
          <div
            className={combineClassNames(
              "flex-center empty-states-icon",
              customIconClass,
            )}
          >
            <Icon />
          </div>
        )}
        {(titleMsg || description) && (
          <div className="empty-states-copy">
            {titleMsg && (
              <WPTypography
                className="empty-states-title"
                asElement="h2"
                text={titleMsg}
              />
            )}
            {description && (
              <WPTypography
                className="empty-states-description"
                fontSize={14}
                text={description}
              />
            )}
          </div>
        )}
        {buttonText && (
          <WPButton
            id="custom-button"
            onClick={onButtonClick}
            size="medium"
            customClass="custom-button-margin"
          >
            {buttonText}
          </WPButton>
        )}
      </div>
    </div>
  );
};

WPEmptyStates.propTypes = {
  description: PropTypes.string,
  titleMsg: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.elementType,
  buttonText: PropTypes.string,
  onButtonClick: PropTypes.func,
};

export default WPEmptyStates;
